
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11 8.75V12.43C11 12.78 11.19 13.11 11.49 13.29L14.61 15.14C14.97 15.35 15.43 15.23 15.64 14.88C15.85 14.52 15.74 14.06 15.38 13.85L12.51 12.14V8.74C12.5 8.34 12.16 8 11.75 8C11.34 8 11 8.34 11 8.75ZM21 9.5V4.21C21 3.76 20.46 3.54 20.15 3.86L18.37 5.64C16.56 3.83 13.98 2.79 11.16 3.04C6.97001 3.42 3.52001 6.79 3.06001 10.98C2.46001 16.4 6.69001 21 12 21C16.59 21 20.38 17.56 20.93 13.12C21 12.52 20.53 12 19.93 12C19.43 12 19.01 12.37 18.95 12.86C18.52 16.35 15.51 19.05 11.9 19C8.19001 18.95 5.06001 15.82 5.00001 12.1C4.94001 8.2 8.11001 5 12 5C13.93 5 15.68 5.79 16.95 7.05L14.86 9.14C14.54 9.46 14.76 10 15.21 10H20.5C20.78 10 21 9.78 21 9.5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-update`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconUpdate

    ```js
    <b-new-b-icon-update />
    ```
</docs>


